module.exports = __webpack_public_path__ + "media/flags/sn-2127f978.svg";